export default {
  namespaced: true,
  state: {
    fuelLevyPrice: 100,
  },
};
